import { builder_listTestimonials } from './scripts/builder/builder_listTestimonials'
import { builder_supportedSoftwareCarousel } from './scripts/builder/builder_supportedSoftwareCarousel'
import { caseStudyListNewControls } from './scripts/caseStudySlider'
import { tagFilterCaseStudy } from './scripts/caseStudyDetail/tagFilterCaseStudy'
import { masonryCaseStudies } from './scripts/caseStudyDetail/masonryCaseStudies'
import { pricingExtraTextManager } from './scripts/pricingExtraTextManager'
import { hexController } from './scripts/hexController'
import { caseStudyDetailSwitcher } from './scripts/caseStudyDetailSwitcher'
import { mailFormHandler } from './scripts/mailForm'
import { faqListControls, faqSearchFilter } from './scripts/faqComponent'
import { massHookCheckboxes, massHookDatepickers, massHookTooltips } from './scripts/inputWrapper'
import { headerComponent } from './scripts/headerComponent'
import { headerMenu } from './scripts/headerMenu'
import { globals } from '@/src/globals'

import * as styles from './styles/index.scss'
import { helpHeaderComponent } from './scripts/helpHeaderComponent'
import { supportedSoftwareCarousel } from './scripts/supportedSoftwareCarousel'
import { pricingHoverEffect } from './scripts/pricingHoverEffect'
import { blockAnimator } from './scripts/blockAnimator'
import { anchorLinkScroller } from './scripts/anchorLinkScroller'
import { builder_fullwidthVideo } from './scripts/builder/builder_fullwidthVideo'

// Main file
const datarios = (input: any): void => {
  const processedStyles = styles

  globals.externalInput = input

  headerComponent()
  headerMenu()

  const hexControllerWrapper = document.querySelector('.js-hex-2022-wrapper') as unknown as HTMLElement
  if (hexControllerWrapper) {
    hexController(hexControllerWrapper)
  }

  const faqListWrapper = document.querySelector('.js-faqList') as unknown as HTMLElement
  if (faqListWrapper) {
    faqListControls(faqListWrapper)
  }

  const helpHeaderWrapper = document.querySelector('.js-helpSearchForm') as unknown as HTMLFormElement
  if (helpHeaderWrapper) {
    helpHeaderComponent(helpHeaderWrapper)
  }

  const faqSearch = document.querySelector('.js-faqSearchInput') as unknown as HTMLInputElement
  if (faqListWrapper && faqSearch) {
    faqSearchFilter(faqSearch, faqListWrapper)
  }

  const caseStudyDetails = document.querySelector('.js-caseStudyDetails') as unknown as HTMLElement
  if (caseStudyDetails) {
    caseStudyDetailSwitcher(caseStudyDetails)
  }

  const pricingBlock = document.querySelector('.js-pricing') as unknown as HTMLElement
  if (pricingBlock) {
    pricingHoverEffect(pricingBlock)
    pricingExtraTextManager(pricingBlock)
  }

  const mailFormWrapper = document.querySelector('.js-mailForm') as unknown as HTMLElement
  if (mailFormWrapper) {
    mailFormHandler(mailFormWrapper)
  }

  const checkboxList = document.querySelectorAll('.js-inputCheckbox') as unknown as HTMLElement[]
  if (checkboxList) {
    massHookCheckboxes(checkboxList)
  }

  const tooltipList = document.querySelectorAll('.js-inputTooltip') as unknown as HTMLElement[]
  if (tooltipList) {
    massHookTooltips(tooltipList)
  }

  const datepickerList = document.querySelectorAll('.js-inputDatepicker') as unknown as HTMLElement[]
  if (datepickerList) {
    massHookDatepickers(datepickerList)
  }

  const caseStudyListSliderWrapper = document.querySelector('.js-caseStudySlider_2022') as unknown as HTMLElement
  if (caseStudyListSliderWrapper) {
    caseStudyListNewControls(caseStudyListSliderWrapper)
    // testimonialsSmallFlippersSlider(testimonialsSmallWrapper)
  }

  supportedSoftwareCarousel()
  blockAnimator()
  anchorLinkScroller()
  masonryCaseStudies()
  tagFilterCaseStudy()

  // Builder
  builder_supportedSoftwareCarousel()
  builder_fullwidthVideo()
  builder_listTestimonials()
}

export default datarios
